import focus from '@alpinejs/focus';
import Alpine from 'alpinejs';

import {announcement, announcementSlider, announcementTicker} from '../alpine/data/announcement';
import productAddButtonForm from '../alpine/data/product-add-button-form';
import productQuickViewButton from '../alpine/data/product-quick-view-button';
import productGridItemQuickAddMenu from '../alpine/data/product-grid-item-quick-add-menu';
import toggle from '../alpine/data/toggle';
import tabs from '../alpine/data/tabs';
import overflow from '../alpine/data/overflow';
import hold from '../alpine/directives/hold';
import targetReferrer from '../alpine/directives/target-referrer';
import nudge from '../alpine/magics/nudge';

/* Data */

Alpine.data('announcement', announcement);
Alpine.data('announcementSlider', announcementSlider);
Alpine.data('announcementTicker', announcementTicker);
Alpine.data('productAddButtonForm', productAddButtonForm);
Alpine.data('productQuickViewButton', productQuickViewButton);
Alpine.data('productGridItemQuickAddMenu', productGridItemQuickAddMenu);
Alpine.data('toggle', toggle);
Alpine.data('tabs', tabs);
Alpine.data('overflow', overflow);

/* Magics */

Alpine.magic('nudge', nudge);

/* Directives */

Alpine.directive('hold', hold);
Alpine.directive('target-referrer', targetReferrer);

/* Plugins */

Alpine.plugin(focus);

/* Initialization */

Alpine.start();

// Mainly for Alpine.js devtools to work
window.Alpine = Alpine;
